import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import http from "app/requests/axiosInstance";
import { getSale } from "./salesSlice";

export enum PaymentMethod {
  CASH = "cash",
  CREDIT_CARD = "credit_card",
}

export interface PaymentTransactionSliceState {
  id: number;
  sale?: any;
  paymentLink?: any;
  referenceNumber?: number;
  paymentMethod?: PaymentMethod;
  total: string;
  totalCents: number;
  subtotalCents: number;
  subtotal: string;
  taxCents: number;
  tax: string;
  tipsCents: number;
  tips: string;
  createdAt: string;
  updatedAt: string;
}

// export const get = createAsyncThunk(
// );

export const createPaymentTransaction = createAsyncThunk(
  "paymentTransaction/createPaymentTransaction",
  async (
    {
      subtotalCents,
      taxCents,
      discountCents,
      totalCents,
      tipsCents,
      saleId,
      paymentMethod,
      voidPreviousPayments,
        cardToken,
        withExistingCard,
        feeType,
        feeBasisPoint
    }: any,
    thunkAPI
  ) => {

    const { data } = await http.post("/v1/payment_transactions", {
      paymentTransaction: {
        subtotalCents,
        taxCents,
        discountCents,
        feeType,
        feeBasisPoint,
        totalCents,
        tipsCents,
        saleId,
        paymentMethod,
        voidPreviousPayments, cardToken,
          withExistingCard
      },
    });
    // thunkAPI.dispatch(getSale({ id: data.sale.id }));
    return data;
  }
);
export const createPOSPaymentTransaction = createAsyncThunk(
  "paymentTransaction/createPOSPaymentTransaction",
  async (
    {
      subtotalCents,
      taxCents,
      discountCents,
      feeType,
      feeBasisPoint,
      totalCents,
      tipsCents,
      saleId,
    }: any,
    thunkAPI
  ) => {
    try {
      const { data } = await http.post("/v1/spin_payment_transactions", {
        paymentTransaction: {
          subtotalCents,
          taxCents,
          discountCents,
          feeType,
          feeBasisPoint,
          totalCents,
          tipsCents,
          saleId,
          paymentMethod: "CARD",
        },
      });
      return data;
    } catch (error: any) {
      // The interceptor rejects with the response; keep the terminal's reason
      throw new Error(error?.data?.error ?? "Payment failed. Please try again.");
    }
  }
);


export const payWithCreditCard = createAsyncThunk(
  "paymentTransaction/payWithCreditCard",
  async (
    {
      source,
      amount,
      name,
      expiryMonth,
      expiryYear,
      tip,
      saleId,
      totalCents,
      subtotalCents,
      taxCents,
      tax,
      tipsCents,
      withExistingCard,
      voidPreviousPayments,
    }: any,
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(
        `/v1/payment_transactions/pay_with_credit_card`,
        {
          source,
          amount,
          name,
          expiryMonth,
          expiryYear,
          tip,
          saleId,
          totalCents,
          subtotalCents,
          taxCents,
          tax,
          tipsCents,
          withExistingCard,
          voidPreviousPayments,
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const testApiKeys = createAsyncThunk(
  "sales/testApiKeys",
  async (
    {
      acceptBlueTokenizationApi,
      acceptBlueApiKey,
      acceptBlueApiPin,
    }: {
      acceptBlueTokenizationApi?: string;
      acceptBlueApiKey: string;
      acceptBlueApiPin: string;
    },
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(`/v1/sales/test_charge`, {
        acceptBlueTokenizationApi,
        acceptBlueApiKey,
        acceptBlueApiPin,
      });
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);



export const sendEmailReceipt = createAsyncThunk(
    "paymentTransaction/sendEmailReceipt",
    async (
        {
            saleId
        }: any,
        thunkAPI
    ) => {
        const { data } = await http.post("/v1/send-receipt", {saleId});
        // thunkAPI.dispatch(getSale({ id: data.sale.id }));
        return data;
    }
);

